// import * as Stitches from '@stitches/react';
import { styled } from '@gbm-tech/styles';

export const DatePickerContainer = styled('button', {
  height: '48px',

  display: 'inline-flex',

  fontSize: '1.8rem',

  fontWeight: '400',
  textAlign: 'center',
  color: '$gray700',

  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',

  border: 'none',
  backgroundColor: '$white',

  span: {
    width: '180px',
    padding: '1rem 1.6rem',
  },

  '.calendar': {
    height: '100%',

    padding: '1.3rem 1.4rem',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    backgroundColor: '$white',

    '> svg': {
      fontSize: '2rem',
      color: '$gray600',
    },
  },
});

export const DatePickerStyle = styled('div', {

  '.react-datepicker__aria-live': {
    display: 'none',
  },

  '.react-datepicker__tab-loop': {
    display: 'inline-block',
  },

  '.react-datepicker-popper': {
    zIndex: 99,
  },

  '.react-datepicker-wrapper': {
    width: 'auto',
  },

  '.react-datepicker': {
    fontSize: '1.28rem',
  },

  '.react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name':
    {
      width: '2.72rem',
      lineHeight: '2.72rem',
      margin: '0.265rem',
    },

  '.react-datepicker__month': {
    margin: '0.64rem',
  },

  '.react-datepicker__month-select, .react-datepicker__year-select': {
    border: '1px solid #dae0e7',
    borderRadius: '4px',
    padding: '0.5rem',
  },

  'input.react-datepicker-time__input': {
    border: '1px solid #dae0e7',
    borderRadius: '4px',
    padding: '0.6rem',
  },

  '.react-datepicker__current-month': {
    fontSize: '1.5rem',
    color: '#404A59',
    fontWeight: '500',
    paddingBottom: '0.6rem',
  },

  '.react-datepicker__month-read-view--selected-month, .react-datepicker__year-select':
    {
      border: '1px solid #dae0e7',
      borderRadius: '4px',
      padding: '0.5rem',
    },

  '.react-datepicker__navigation': {
    padding: '2.2rem 0',
  },

  '.react-datepicker__header': {
    background: '$lightHeader',
  },

  '.react-datepicker__day--outside-month': {
    opacity: '0.5',
  },

  '.react-datepicker-time__header': {
    fontSize: '1.5rem',
  },

  '.react-datepicker__input-time-container': {
    display: 'flex',
    marginLeft: '0',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 15px'
  },

  '.react-datepicker-time__input': {
    'input': {
      minWidth: '130px'
    },
  },

  'input[type="time"]::-webkit-calendar-picker-indicator': {
    opacity: '0.6'
  },

  '.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range, .react-datepicker__month-text--selected, .react-datepicker__month-text--in-selecting-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--selected, .react-datepicker__quarter-text--in-selecting-range, .  react-datepicker__quarter-text--in-range, .  react-datepicker__year-text--selected, .             react-datepicker__year-text--in-selecting-range,                                  .react-datepicker__year-text--in-range, .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected':
    {
      backgroundColor: '#094fb8',
      color: '#f4f5f6',
    },

  '.span-text': {
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
  },
});
